import { fromJS } from 'immutable';

import {
  REMOVE_CUSTOMER_FROM_WAITING_LIST,
  REMOVE_CUSTOMER_FROM_WAITING_LIST_SUCCESS,
  CONFIRM_BARBER_SUCCESS,
  USER_TOKEN_ERROR,
  USER_TOKEN_SUCCESS,
  VERIFY_EMAIL,
  CONFIRM_BARBER,
  VERIFY_PASSWORD,
  VERIFY_PASSWORD_ERROR,
  VERIFY_PASSWORD_SUCCESS,
  CAMPAIGN_UNSUBSCRIBE,
  CAMPAIGN_UNSUBSCRIBE_SUCCESS,
  CAMPAIGN_UNSUBSCRIBE_ERROR,
} from '../constants';

const initialState = fromJS({
  errorMessage: null,
  successMessage: null,
  isFetching: false,
});

export default function confirmationReducer(state = initialState, action) {
  switch (action.type) {
    case VERIFY_EMAIL:
    case CONFIRM_BARBER:
    case VERIFY_PASSWORD:
    case REMOVE_CUSTOMER_FROM_WAITING_LIST:
    case CAMPAIGN_UNSUBSCRIBE:
      return state.set('isFetching', true);

    case VERIFY_PASSWORD_SUCCESS:
    case USER_TOKEN_SUCCESS:
    case REMOVE_CUSTOMER_FROM_WAITING_LIST_SUCCESS:
    case CONFIRM_BARBER_SUCCESS:
    case CAMPAIGN_UNSUBSCRIBE_SUCCESS:
      return state.withMutations(s =>
        s.set('successMessage', action.payload)
          .set('errorMessage', false)
          .set('isFetching', false)
      );

    case VERIFY_PASSWORD_ERROR:
    case USER_TOKEN_ERROR:
    case CAMPAIGN_UNSUBSCRIBE_ERROR:
      return state.withMutations(s =>
        s.set('errorMessage', action.payload)
          .set('isFetching', false)
      );

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/confirmation/reducer.js